// Production: same-origin (served via nginx). Dev: explicit backend port.
export const DOMAIN =
  process.env.REACT_APP_API_DOMAIN ??
  (window.location.port === '3000' ||
   window.location.port === '3001' ||
   window.location.hostname === 'localhost' ||
   window.location.hostname === '127.0.0.1' ||
   /^(192\.168\.|10\.|172\.(1[6-9]|2[0-9]|3[0-1])\.)/.test(window.location.hostname)
    ? `http://${window.location.hostname}:8000`
    : `${window.location.protocol}//${window.location.host}`);
